export const setActiveMenu = (ActiveMenu) => {
    return {
        type: 'SET_ActiveMenu',
        ActiveMenu
    }
}